<template>
  <div class="page">
    <van-nav-bar :title="$t('recharge.recharge')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <!-- 顶部余额卡片 -->
    <div class="balance-card">
      <p class="balance-label">{{ $t("recharge.curr_balance") }}</p>
      <p class="balance-value">{{ balance }} <span class="balance-unit">{{ $t("reservation.unit") }}</span></p>
    </div>

    <!-- 输入区 -->
    <div class="body">
      <div class="input-card">
        <p class="input-label">{{ $t("recharge.input_money") }}</p>
        <div class="amount-wrap">
          <span class="currency-sign">$</span>
          <input
            v-model="money"
            class="amount-input"
            type="number"
            inputmode="decimal"
            :placeholder="$t('recharge.input_money')"
          />
        </div>
        <div class="divider"></div>

        <!-- 快捷金额 -->
        <div class="quick-amounts">
          <div
            v-for="n in quickList"
            :key="n"
            class="quick-item"
            :class="{ 'quick-item--active': money == n }"
            @click="money = String(n)"
          >{{ n }}</div>
        </div>
      </div>

      <van-button class="submit-btn" block @click="onSubmit">
        {{ $t('recharge.next_step') }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      balance: 0,
      money: '',
      quickList: [100, 300, 500, 1000, 2000, 5000],
    };
  },
  mounted() {
    this.balance = this.$route.params.balance || 0;
  },
  methods: {
    back() {
      return window.history.back();
    },
    onSubmit() {
      const val = Number(this.money);
      if (!val || val <= 0) {
        this.$toast(this.$t('reservation.money_err'));
        return;
      }
      this.$router.push({ path: '/ServiceOnline' });
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.page {
  min-height: 100vh;
  background: #f4f4f8;
}

/* 导航栏 */
.nav-bar {
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}

/* 余额卡片 */
.balance-card {
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
  padding: 30px 40px 50px;
  text-align: center;
}
.balance-label {
  font-size: 26px;
  color: rgba(255,255,255,0.75);
  margin-bottom: 10px;
}
.balance-value {
  font-size: 64px;
  font-weight: 700;
  color: #fff;
  line-height: 1.1;
}
.balance-unit {
  font-size: 28px;
  font-weight: 400;
  opacity: 0.8;
}

/* 主体上移叠加卡片 */
.body {
  margin-top: -24px;
  padding: 0 30px 60px;
}

.input-card {
  background: #fff;
  border-radius: 20px;
  padding: 40px 36px 36px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.07);
  margin-bottom: 40px;
}

.input-label {
  font-size: 28px;
  color: #999;
  margin-bottom: 24px;
}

/* 金额输入行 */
.amount-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.currency-sign {
  font-size: 52px;
  font-weight: 700;
  color: #333;
  line-height: 1;
}
.amount-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 56px;
  font-weight: 700;
  color: #222;
  background: transparent;
  min-width: 0;
  &::placeholder {
    color: #ddd;
    font-weight: 400;
    font-size: 44px;
  }
}

.divider {
  height: 2px;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  border-radius: 2px;
  margin: 20px 0 32px;
}

/* 快捷金额 */
.quick-amounts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.quick-item {
  height: 72px;
  border-radius: 12px;
  border: 2px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: #555;
  font-weight: 600;
  background: #fafafa;
  transition: all 0.2s ease;
}
.quick-item--active {
  border-color: #c471a0;
  background: linear-gradient(135deg, rgba(230,195,161,0.15), rgba(196,113,160,0.12));
  color: #c471a0;
}

/* 提交按钮 */
.submit-btn {
  height: 96px !important;
  border-radius: 48px !important;
  border: none !important;
  background: linear-gradient(270deg, #e6c3a1, #7e5678) !important;
  font-size: 34px !important;
  font-weight: 700 !important;
  color: #fff !important;
  box-shadow: 0 8px 24px rgba(126,86,120,0.35);
}
</style>
